import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { jobAPI } from '../../../api'
import {
  JOB_INVITE_BULK_INVITE_REQUEST,
  JOB_INVITE_BULK_INVITE_SUCCESS,
  JOB_INVITE_BULK_INVITE_FAILED,
} from './actionTypes'

export const jobInviteBulkInvitePA = createPromiseAction(
  JOB_INVITE_BULK_INVITE_REQUEST,
  JOB_INVITE_BULK_INVITE_SUCCESS,
  JOB_INVITE_BULK_INVITE_FAILED
)()

function* submit(action) {
  try {
    const { id, params } = action.payload

    const response = yield call(jobAPI.bulkInvite, id, params)

    const { data } = response

    yield put(jobInviteBulkInvitePA.success({}))

    resolvePromiseAction(action, { ...data })
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* bulkInviteSaga() {
  yield takeEvery(jobInviteBulkInvitePA.request, submit)
}
